document.addEventListener('DOMContentLoaded', function() {
  const colorMap = {
    'negro': '#1a1a1a', 'blanco': '#F5F5F5', 'gris': '#808080',
    'gris claro': '#B0B0B0', 'grafito': '#4a4a4a', 'carbón': '#3C3C3C',
    'cenizo': '#9E9E9E', 'gris oxford': '#4A4E69', 'oxford': '#4A4E69',
    'plateado': '#C0C0C0', 'aluminio': '#C0C0C0', 'mineral': '#C0C0C0',
    'bronce': '#CD7F32', 'azul': '#1565C0', 'celeste': '#87CEEB',
    'azul cielo': '#87CEEB', 'azul marino': '#0D1B6E', 'turquesa': '#00BCD4',
    'azul turquesa': '#00BCD4', 'peacock': '#005F6B', 'verde': '#2E7D32',
    'oliva': '#808000', 'olivo': '#808000', 'eucalipto': '#44786A',
    'verde agave': '#4B7A5A', 'pistache': '#93C572', 'rojo': '#C62828',
    'coral': '#FF6B6B', 'rosa': '#E91E8C', 'fucsia': '#FF007F',
    'berenjena': '#6A0F49', 'morado': '#6A1B9A', 'púrpura': '#7B1FA2',
    'violeta': '#7B1FA2', 'vino': '#7B1829', 'naranja': '#FF6600',
    'marigold': '#FFC107', 'amarillo': '#FDD835', 'mostaza': '#C8A000',
    'ámbar': '#FFBF00', 'ambar': '#FFBF00', 'tabaco': '#8B5E3C',
    'arena': '#C2A882', 'canyon': '#C2A882', 'beige': '#D4B896',
    'capuccino': '#D4B896', 'chocolate': '#5D3A1A', 'marrón': '#5D3A1A',
    'café': '#6F4E37', 'nogal': '#7B4F2E', 'cocoa': '#6F4E37',
    'wengue': '#3D2B1F', 'ébano boreal': '#2C1A0E', 'ebano boreal': '#2C1A0E',
    'madera clara': '#C4A882', 'madera oscura': '#4A2E1A', 'madera obscura': '#4A2E1A',
    'natural': '#C4A882', 'encino': '#C4A882', 'encino polar': '#C4A882',
    'nightfall': '#1C2340', 'alpine': '#F5F5F5', 'fog': '#D6D6D6',
    'glacier': '#C0C0C0', 'off white': '#F5F5F5', 'perla': '#F5F5F5',
    'nogal neo': '#7B4F2E', 'cambridge walnut': '#C4A882',
    'roble eternity': '#C4A882', 'roble renovales': '#C4A882',
    'roble trufa': '#C4A882', 'olmo volga': '#C4A882', 'torrente': '#C4A882',
    'aeron carbon': '#2a2a2a', 'aeron grafito': '#4a4a4a',
    'aeron mineral': '#C0C0C0', 'aeron onix': '#2a2a2a',
    'marsala': '#9E3B46',
    'precompuesto cenizo': '#9E9E9E', 'gris gu': '#808080',
    'blanco frosty': '#F5F5F5', 'carrara blanco': '#F5F5F5', 'carrara negro': '#1a1a1a',
  };

  function extractColorName(bg) {
    // Extract content between "to right," and the closing ")"
    const prefixMatch = bg.match(/linear-gradient\(to right,\s*([\s\S]+)\)/i);
    if (!prefixMatch) return null;
    const inner = prefixMatch[1].trim();
    // The format is "colorname, colorname" — split at the last ", " to get the first color
    const lastComma = inner.lastIndexOf(', ');
    if (lastComma === -1) return inner.toLowerCase().trim();
    return inner.substring(0, lastComma).toLowerCase().trim();
  }

  function fixSwatches() {
    document.querySelectorAll('.block-swatch__color, .color-swatch').forEach(el => {
      const bg = el.style.getPropertyValue('--swatch-background');
      if (!bg || bg.includes('#') || !bg.includes('linear-gradient(to right')) return;

      const colorName = extractColorName(bg);
      if (!colorName) return;

      const hex = colorMap[colorName];
      if (hex) {
        el.style.setProperty('--swatch-background',
          `linear-gradient(to right, ${hex}, ${hex})`, 'important');
        if (hex === '#F5F5F5') el.style.setProperty('box-shadow','inset 0 0 0 1px #c8c8c8');
      }
    });
  }

  fixSwatches();
  const observer = new MutationObserver(fixSwatches);
  observer.observe(document.body, { childList: true, subtree: true });
});

// ── VS Price Comparison: dynamic updates on variant change ──
(function() {
  function fmt(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  document.addEventListener('variant:change', function(e) {
    const variant = e.detail && e.detail.variant;
    if (!variant) return;
    const form = e.target;
    const formId = form && form.id;
    if (!formId) return;

    const hasCompare = variant.compare_at_price > variant.price;
    const savings = variant.compare_at_price - variant.price;

    // Update VS container
    const vsContainer = document.querySelector('.prt-vs-container[data-form="' + formId + '"]');
    if (vsContainer) {
      vsContainer.hidden = !hasCompare;
      if (hasCompare) {
        const ourPrice = vsContainer.querySelector('.prt-vs-our-price');
        if (ourPrice) ourPrice.innerHTML = fmt(variant.price);
      }
    }

    // Update savings banner
    const vsSavings = document.querySelector('.prt-vs-savings[data-form="' + formId + '"]');
    if (vsSavings) {
      vsSavings.hidden = !hasCompare;
      if (hasCompare) {
        const amountEl = vsSavings.querySelector('.prt-vs-amount');
        if (amountEl) amountEl.textContent = fmt(savings);
      }
    }

    // Update plain price (shown when no compare)
    const vsPlain = document.querySelector('.prt-vs-plain[data-form="' + formId + '"]');
    if (vsPlain) {
      vsPlain.hidden = hasCompare;
      if (!hasCompare) {
        const priceEl = vsPlain.querySelector('span');
        if (priceEl) priceEl.textContent = fmt(variant.price);
      }
    }
  }, true);
})();
